<template>

  <div class="image-select-wrap">
    <el-radio-group
      v-if="!multiple"
      v-model="selectValue[0]"
      @change="selectChange"
      :disabled="isAnswer"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="img-radio-item"
        :class="{ 'is-selected': isOptionSelected(option), 'is-exam-answer': shouldHighlightExamAnswer(option) }"
      >
        <div
          class="image"
          @click.stop="openPreview(option.image)"
        >
          <el-image
            :src="option.image"
            class="image-el"
            fit="scale-down"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline" />
            </div>
          </el-image>
        </div>
        <el-radio
          :label="option.label"
          :class="{ 'is-exam-answer': shouldHighlightExamAnswer(option) }"
        >{{ option.label }}{{ shouldHighlightExamAnswer(option) ? '（正确）' : '' }}</el-radio>
      </div>
    </el-radio-group>
    <el-checkbox-group
      v-else
      v-model="selectValue"
      @change="selectChange2"
      :disabled="isAnswer"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="img-radio-item"
        :class="{ 'is-selected': isOptionSelected(option), 'is-exam-answer': shouldHighlightExamAnswer(option) }"
      >
        <div
          class="image"
          @click.stop="openPreview(option.image)"
        >
          <el-image
            :src="option.image"
            class="image-el"
            fit="scale-down"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline" />
            </div>
          </el-image>
        </div>
        <el-checkbox
          :label="option.label"
          :class="{ 'is-exam-answer': shouldHighlightExamAnswer(option) }"
        >{{ option.label }}{{ shouldHighlightExamAnswer(option) ? '（正确）' : '' }}</el-checkbox>
      </div>
    </el-checkbox-group>
    <el-dialog
      :visible.sync="previewVisible"
      append-to-body
      :modal-append-to-body="true"
      fullscreen
      :show-header="false"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="question-desc-image-preview-dialog"
      :z-index="4000"
    >

      <button
        type="button"
        class="question-desc-image-preview-close"
        aria-label="关闭预览"
        @click="closePreview"
      >
        <i class="el-icon-close" />
      </button>
      <div class="question-desc-image-preview-body">
        <img
          :src="previewImageUrl"
          alt=""
          class="question-desc-image-preview-img"
        />
      </div>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    name: 'ImageSelect',
    props: {
      value: {
        type: Array,
        default: function() {
          return [1]
        },
      },
      options: {
        type: Array,
        default: function() {
          return []
        },
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      isAnswer: {
        type: Boolean,
        default: false
      },
      // 编辑页预览正确答案样式；填写中不得开启
      showAnswerPreview: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selectValue: this.value,
        previewVisible: false,
        previewImageUrl: ''
      }
    },
    watch: {

    },
    methods: {
      shouldHighlightExamAnswer(option) {
        return !!(option && option.isAnswer && (this.isAnswer || this.showAnswerPreview))
      },
      openPreview(imageUrl) {
        if (!imageUrl) {
          return
        }
        this.previewImageUrl = imageUrl
        this.previewVisible = true
      },
      closePreview() {
        this.previewVisible = false
      },
      selectChange(e) {
        this.$set(this, 'selectValue',[e])
        this.$emit("update:value", [e])
      },
      selectChange2(e) {
        this.$set(this, 'selectValue',e)
        this.$emit("update:value", e)
      },
      isOptionSelected(option) {
        if (this.multiple) {
          return this.selectValue.includes(option.label)
        } else {
          return this.selectValue[0] === option.label
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  $image-select-gap: 10px;

  .image-select-wrap {
    width: 100%;
    box-sizing: border-box;
  }

  ::v-deep .el-radio-group,
  ::v-deep .el-checkbox-group {
    display: flex !important;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
    gap: $image-select-gap;
    margin: 0;
  }

  .img-radio-item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 8px 12px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
    flex: 0 1 auto;
    min-width: 0;
    transition: transform 0.16s ease-out, box-shadow 0.16s ease-out, border-color 0.16s ease-out, background-color 0.16s ease-out;

    &.is-selected {
      border-color: var(--form-theme-color, #4c4edb) !important;
      background: rgba(76, 78, 219, 0.08);
      transform: translateY(-2px);
      box-shadow: 0 6px 14px rgba(76, 78, 219, 0.18), 0 0 0 1px rgba(76, 78, 219, 0.22);
    }

    .image {
      width: 100px;
      height: 100px;
      margin: 0 0 8px;
      border-radius: 6px;
      overflow: hidden;
      background: #f5f7fa;
      cursor: pointer;
    }

    .image ::v-deep .image-el.el-image {
      display: block;
      width: 100%;
      height: 100%;
    }

    ::v-deep .el-image__inner {
      object-fit: contain;
    }

    ::v-deep .el-radio,
    ::v-deep .el-checkbox {
      display: inline-flex;
      align-items: flex-start;
      justify-content: center;
      width: 100%;
      margin: 0 !important;
      height: auto;
      line-height: 1.45;
      white-space: normal;
    }

    ::v-deep .el-radio__label,
    ::v-deep .el-checkbox__label {
      white-space: normal;
      word-break: break-word;
      line-height: 1.45;
      padding-left: 6px;
    }

    &.is-exam-answer {
      border-color: rgba(103, 194, 58, 0.65) !important;
      background: rgba(103, 194, 58, 0.06);
    }

    ::v-deep .el-radio.is-exam-answer .el-radio__input .el-radio__inner {
      border-color: #67c23a;
      background: #67c23a;
    }

    ::v-deep .el-radio.is-exam-answer .el-radio__input .el-radio__inner::after {
      width: 4px;
      height: 4px;
      background-color: #fff;
      transform: translate(-50%, -50%) scale(1);
    }

    ::v-deep .el-checkbox.is-exam-answer .el-checkbox__input .el-checkbox__inner {
      border-color: #67c23a;
      background-color: #67c23a;
    }

    ::v-deep .el-checkbox.is-exam-answer .el-checkbox__input .el-checkbox__inner::after {
      border-color: #fff;
      transform: rotate(45deg) scale(1);
    }
  }

  @media screen and (max-width: 768px) {
    .img-radio-item {
      flex: 0 0 calc((100% - #{$image-select-gap}) / 2);
      max-width: calc((100% - #{$image-select-gap}) / 2);
      padding: 8px 6px 10px;

      .image {
        display: block;
        width: 100%;
        max-width: none;
        height: auto;
        aspect-ratio: 1;
        max-height: 160px;
      }
    }

    /* 仅一项时占满一行，避免半宽留白 */
    .img-radio-item:only-child {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }

  ::v-deep .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 30px;
  }
</style>

<style lang="scss">
/* custom-class 在 .el-dialog 根节点，与 QuestionDescImage 预览样式一致 */
.question-desc-image-preview-dialog {
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.88);
}

.question-desc-image-preview-dialog .el-dialog__header {
  display: none;
}

.question-desc-image-preview-dialog .el-dialog__body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  overflow: auto;
}

.question-desc-image-preview-close {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 4001;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

.question-desc-image-preview-close:hover {
  background: rgba(255, 255, 255, 0.32);
}

.question-desc-image-preview-close:focus {
  outline: 2px solid rgba(255, 255, 255, 0.6);
  outline-offset: 2px;
}

.question-desc-image-preview-body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
}

.question-desc-image-preview-img {
  max-width: 100%;
  max-height: calc(100vh - 48px);
  width: auto;
  height: auto;
  object-fit: contain;
}
</style>
